/**
 * 집밥 유형 (기존 user-survey 설문 결과 타입)
 * user-survey 서비스 제거 후 ChannelTalk, me 타입 호환용으로 유지
 */
export enum HomeCooking {
  SURVIVAL_SPECIALIST = 'SURVIVAL_SPECIALIST',
  GRASSHOPPER = 'GRASSHOPPER',
  ALPHAGO = 'ALPHAGO',
  HIDDEN_ENTHUSIAST = 'HIDDEN_ENTHUSIAST',
  TYCOON = 'TYCOON',
  ASSAULT_LEADER = 'ASSAULT_LEADER',
  PROMISING = 'PROMISING',
  ARTIST = 'ARTIST',
  CHALLENGER = 'CHALLENGER',
  NOMAD = 'NOMAD',
  NATURALIST = 'NATURALIST',
  COLUMBUS = 'COLUMBUS',
}

export const HomeCookingTypeKorean: Record<HomeCooking, string> = {
  [HomeCooking.SURVIVAL_SPECIALIST]: '집밥 생존 전문가',
  [HomeCooking.GRASSHOPPER]: '집밥 베짱이',
  [HomeCooking.ALPHAGO]: '집밥 알파고',
  [HomeCooking.HIDDEN_ENTHUSIAST]: '겉바속촉 집밥러',
  [HomeCooking.TYCOON]: '집밥 타이쿤',
  [HomeCooking.ASSAULT_LEADER]: '집밥 돌격대장',
  [HomeCooking.PROMISING]: '집밥 꿈나무',
  [HomeCooking.ARTIST]: '집밥 아티스트',
  [HomeCooking.CHALLENGER]: '집밥 도전가',
  [HomeCooking.NOMAD]: '집밥 유목민',
  [HomeCooking.NATURALIST]: '집밥계의 자연인',
  [HomeCooking.COLUMBUS]: '집밥 콜롬버스',
};
